import { render } from "./IndexOrders.vue?vue&type=template&id=1186f9b0&scoped=true"
import script from "./IndexOrders.vue?vue&type=script&lang=js"
export * from "./IndexOrders.vue?vue&type=script&lang=js"

import "./IndexOrders.vue?vue&type=style&index=0&id=1186f9b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1186f9b0"]])

export default __exports__